import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { Slide, toast } from "react-toastify";
import { useGlobalContext } from "../../../../context/context";
import axios from "axios";
import { ColorRing } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

const OTPModal = ({
  toggleOTPModal,
  toggleWithdrawalModal,
  getValues,
  withdrawalPath,
  method,
}) => {
  const [otpCode, setcode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { userDetails, baseUrl, getUser, geKYCDetails, getAllWithdrawals } =
    useGlobalContext();
  const accessToken = JSON.parse(sessionStorage.getItem("accessToken"));
  const user = JSON.parse(sessionStorage.getItem("user")) || userDetails;
  const adminToken =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY2YmRmMjdkMzg5MTA2MzRkZTliMGQ2NiIsImlzQWRtaW4iOnRydWUsImlhdCI6MTc1NTg2NDI1MiwiZXhwIjoxNzU2MTIzNDUyfQ.PP_8SqY2pQ-O9j_0yS3c0BOfGEZ1isSWmDwkHez5rv4";
  const {
    userOtp,
    _id,
    transferStep,
    otpMessage,
    email,
    country: { symbol },
    lastName,
    firstName,
  } = user;

  const validateWithdrawal = () => {
    const data = getValues();
    let pzcDetails = {};
    pzcDetails.accountNumber = "1234567890";
    pzcDetails.accountType = "savings";
    pzcDetails.accountName = `${firstName} ${lastName}`;
    pzcDetails.transactiontype = method;
    pzcDetails.bankName = "ertyuytre";
    pzcDetails.userId = _id;
    pzcDetails.email = data.email;
    pzcDetails.symbol = symbol;
    pzcDetails.withdrawalPath = withdrawalPath;
    pzcDetails.amount = data.amount;

    if (otpCode == userOtp && transferStep !== 9) {
      setLoading(true);
      setTimeout(() => {
        axios
          .put(
            `${baseUrl}users/user/${_id}`,
            { transferStep: transferStep + 1 },
            { headers: { token: accessToken } }
          )
          .then((response) => {
            setLoading(false);
            toast.success("Withdrawal is Processing");
            getUser(accessToken, _id);
            handleOtp();
            setTimeout(() => {
              toggleOTPModal();
              toggleWithdrawalModal();
            }, 2000);
          })
          .catch((error) => {
            setLoading(false);
          });
      }, 3000);
    } else if (otpCode == userOtp && transferStep === 9) {
      data.email = email;
      data.userId = _id;
      data.symbol = symbol;
      data.withdrawalPath = withdrawalPath;
      data.transactiontype = method;

      setLoading(true);
      axios
        .post(
          `${baseUrl}transfer`,
          method === "bank transfer" ? data : pzcDetails,
          {
            headers: { token: accessToken },
          }
        )
        .then((response) => {
          toast.success("Withdrawal successful");
          setLoading(false);
          getUser(accessToken, _id);
          handleOtp();
          getAllWithdrawals(accessToken, _id);
          setTimeout(() => {
            toggleWithdrawalModal();
          }, 2000);
        })
        .catch((err) => {
          setLoading(false);
          if (err?.response?.data?.keyPattern?.referenceNumber === 1) {
            toast.error("Withdrawal Already Made", {
              transition: Slide,
              theme: "dark",
            });
          }
        });
    } else {
      toast.error("Wrong Code");
    }
  };

  const handleOtp = () => {
    axios
      .put(
        `${baseUrl}users/updatedata/${_id}`,
        { userOtp: 987654321 },
        { headers: { token: adminToken } }
      )
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const notify = () => {
    toast.success("Withdrawal Process Cancelled");
    setTimeout(() => {
      toggleWithdrawalModal();
      toggleOTPModal();
    }, 3000);
  };

  useEffect(() => {
    geKYCDetails(accessToken, _id);
    handleOtp();
  }, []);

  return (
    <>
      <section className="notification_modal otp_modal">
        <div className="notification_container">
          <div className="add_food_item_header">
            <h3 className="dashboard_header_text">Withdrawal</h3>
            <div className="go_back">
              <AiOutlineClose size={20} onClick={notify} />
            </div>
          </div>
          <div className="close_container">
            <p>{otpMessage}</p>
            <div className="input_wrapper">
              <input
                type="text"
                placeholder="Enter Code"
                onChange={(e) => setcode(e.target.value)}
              />
            </div>
          </div>
          <div className="notification_flex">
            <button className="button" onClick={validateWithdrawal}>
              {loading ? (
                <ColorRing
                  visible={true}
                  height="45"
                  width="45"
                  ariaLabel="blocks-loading"
                  wrapperStyle={{}}
                  wrapperClass="blocks-wrapper"
                  colors={["white", "white", "white", "white", "white"]}
                />
              ) : (
                "Enter Code"
              )}
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default OTPModal;
